export const DECASOLICITACAO_POST =
  "mobiliario.cadastroEletronico.decaSolicitacao.DECASOLICITACAO_POST";
export const DECASOLICITACAO_GET =
  "mobiliario.cadastroEletronico.decaSolicitacao.DECASOLICITACAO_GET";
export const DECASOLICITACAO_PUT =
  "mobiliario.cadastroEletronico.decaSolicitacao.DECASOLICITACAO_PUT";
export const DECASOLICITACAO_DELETE =
  "mobiliario.cadastroEletronico.decaSolicitacao.DECASOLICITACAO_DELETE";
export const DECASOLICITACAO_SET =
  "mobiliario.cadastroEletronico.decaSolicitacao.DECASOLICITACAO_SET";
export const DECASOLICITACAO_VALIDAR_TIPO_EMPRESA =
  "mobiliario.cadastroEletronico.decaSolicitacao.DECASOLICITACAO_VALIDAR_TIPO_EMPRESA";
export const PARAMETRO_GET =
  "mobiliario.cadastroEletronico.decaSolicitacao.PARAMETRO_GET";
export const PARAMETRO_SET =
  "mobiliario.cadastroEletronico.decaSolicitacao.PARAMETRO_SET";
export const SOLICITANTE_SET =
  "mobiliario.cadastroEletronico.decaSolicitacao.SOLICITANTE_SET";
export const SOLICITACAO_GET =
  "mobiliario.cadastroEletronico.decaSolicitacao.SOLICITACAO_GET";
export const SET_REDUCER_TYPEDECA =
  "mobiliario.cadastroEletronico.decaSolicitacao.SET_REDUCER_TYPEDECA";
export const SET_REDUCER_LOADDECA =
  "mobiliario.cadastroEletronico.decaSolicitacao.SET_REDUCER_LOADDECA";
export const SET_SOMENTE_ENDERECO_SEDE =
  "mobiliario.cadastroEletronico.decaSolicitacao.SET_SOMENTE_ENDERECO_SEDE";
export const DECASOLICITACAO_LOADGRUPO =
  "mobiliario.cadastroEletronico.decaSolicitacao.DECASOLICITACAO_LOADGRUPO";
export const DECASOLICITACAO_SETCOMBOGRUPO =
  "mobiliario.cadastroEletronico.decaSolicitacao.DECASOLICITACAO_SETCOMBOGRUPO";
export const DECASOLICITACAO_GETMANUAL =
  "mobiliario.cadastroEletronico.decaSolicitacao.DECASOLICITACAO_GETMANUAL";
export const SET_DISABLE_ALL_SOLICITACAO =
  "mobiliario.cadastroEletronico.decaSolicitacao.SET_DISABLE_ALL_SOLICITACAO";
